export default __webpack_public_path__ + "static/080-aff71c3c52083011cdeedf409717f2cf.jpg";